import { Fragment, useContext, useEffect, useState } from "react";
import { MainContext } from "../App";
import Api from "./api/api";
import QrIcon from "../icons/QrIcon";
import functions from "../utilities/functions";
import moment from "moment/moment";
import CloseIcon from "../icons/CloseIcon";
import { isTabletEmbed, postToParent } from "../embed";

function TableEditPopup() {
	const {
		lists,
		setAlertData,
		setLoading,
		setTable,
		setTempTable,
		setFlow,
		initCart,
		tempTable,
		setTableEditPopup,
		setPopupVisible,
		ordersDisabled,
		setQrPopupVisible,
		setQrPopupCloseToTables,
		menu,
		shop,
		settings,
		user,
	} = useContext(MainContext);
	const isAdmin = parseInt(user?.role?.admin) === 1;
	const canViewRequestBill =
		isAdmin || parseInt(user?.role?.waiter_permissions?.request_bill?.view) === 1;
	const canCloseTables = isAdmin || parseInt(user?.role?.waiter_permissions?.tables_close?.view) === 1;
	const [singleOrderMode, setSingleOrderMode] = useState(0);
	const [splittedCovers, setSplittedCovers] = useState([]);
	const [covers, setCovers] = useState(0);

	useEffect(() => {
		setSingleOrderMode(tempTable.single_order_mode);
		setSplittedCovers(tempTable.splitted_covers);
		setCovers(tempTable.covers);
	}, [tempTable]);

	useEffect(() => {
		console.log("covers set to", covers);
	}, [covers]);

	useEffect(() => {
		console.log("splittedCovers set to", splittedCovers);
	}, [splittedCovers]);

	const setList = async (listId) => {
		await editTableById(tempTable.id, {
			list_id: listId,
		});
	};

	const editTableById = async (id, request) => {
		setLoading(true);
		const res = await Api.postProtected("/tables/edit/" + id + "/", request);
		setLoading(false);
		if (res.success == 0) {
			alert(res.error);
			return false;
		}
		if (parseInt(request?.status) === 0) {
			setTable(false);
			setTempTable(false);
			setPopupVisible(false);
			setTableEditPopup(false);
		}
		return true;
	};

	const editTableByIdConfirm = async (id, request) => {
		setAlertData({
			title: "Sei sicuro?",
			message: "",
			showCancelButton: true,
			callback: async function () {
				const success = await editTableById(id, request);
				if (success && parseInt(request?.status) !== 0) setTableEditPopup(false);
			},
		});
	};

	const handleSubmit = async () => {
		initCart();
		setFlow(1);
		setTable(tempTable);
		setTableEditPopup(false);
	};

	const incrementSplittedCovers = (id) => {
		const index = splittedCovers.findIndex((el) => el.id == id);
		if (index > -1) {
			const newData = [...splittedCovers];
			newData[index].qty++;
			setSplittedCovers(newData);
		} else {
			setSplittedCovers([...splittedCovers, { id: id, qty: 1 }]);
		}
	};

	const decrementSplittedCovers = (id) => {
		const index = splittedCovers.findIndex((el) => el.id == id);
		if (index > -1) {
			if (splittedCovers[index].qty == 0) return;
			const newData = [...splittedCovers];
			newData[index].qty--;
			setSplittedCovers(newData);
		} else {
			setSplittedCovers([...splittedCovers, { id: id, qty: 1 }]);
		}
	};

	const getSplittedCovers = (id) => {
		const el = splittedCovers?.find((el) => el.id == id);
		if (el) return el.qty;
		else return 0;
	};

	const getFilteredProducts = (filter) => {
		const res = [];
		for (const course of menu) {
			for (const category of course.categories) {
				for (const product of category.products) {
					if (product[filter] == 1) {
						if (tempTable.list_id) {
							const priceList = product.prices.find(
								(p) => p.list_id == tempTable.list_id && p.price
							);
							const assortment = product.assortment.find(
								(el) =>
									el.shop_id == shop.id &&
									el.list_id == tempTable.list_id &&
									el.active == 1
							);
							if (priceList && assortment)
								res.push({ ...product, price: priceList.price });
						} else res.push(product);
					}
				}
			}
		}
		return res;
	};

	const getPin = () => {
		if (
			settings.selfordering.pin_mode == "generated" ||
			settings.selfordering.pin_mode == "fixed"
		)
			return tempTable.pin;
		if (settings.selfordering.pin_mode == "shop") return shop.selfordering_pin;
		if (settings.selfordering.pin_mode == "disabled") return false;
	};

	return (
		<div className="popup md table-edit-popup">
			<div className="container covers-table table-edit-container">
				<header>
					<div className="buttons-group">
						<button
							className="btn btn-tertiary btn-square"
							onClick={() => setTableEditPopup(false)}
						>
							<CloseIcon />
						</button>
						<div>
							<span>Modifica</span>
							<div className="name-open-table">
								{tempTable.name}
								<span className="extrasmall"> {tempTable.room?.name || ""}</span>
							</div>
						</div>
					</div>
					<div className="buttons-group text-large">
						{getPin() && <div>{"Pin: " + getPin()}</div>}
						<button
							className="btn btn-secondary btn-square btn-icon"
							onClick={() => {
								setQrPopupCloseToTables(false);
								setQrPopupVisible(true);
							}}
						>
							<QrIcon />
						</button>
					</div>
				</header>
				<div className="content table-edit-content">
					{tempTable.status == 1 && (
						<div className="boxed-section list-selector-section">
							<div className="list-selector-head">
								<div className="list-selector-title">Listino</div>
								<div className="list-selector-help">Modifica quello associato al tavolo</div>
							</div>
							<div className="lists-container list-selector-grid">
								{settings.waiter_app.hide_base_list != 1 && (
									<button
										className={
											"btn list-selector-option" +
											(!tempTable.list_id
												? " btn-secondary selected"
												: " btn-tertiary")
										}
										onClick={() => setList(null)}
									>
										Base
									</button>
								)}
								{lists.map((l, i) => (
									<button
										key={i}
										className={
											"btn list-selector-option" +
											(l.id == tempTable.list_id
												? " btn-secondary selected"
												: " btn-tertiary")
										}
										onClick={() => setList(l.id)}
									>
										{l.name}
									</button>
								))}
							</div>
						</div>
					)}

					{!isTabletEmbed && tempTable.status == 1 &&
						(!tempTable.list_id || tempTable.list?.allyoucaneat == 0) && (
							<div className="boxed-section">
								<div className="single-order-toggle-row">
									<div className="single-order-toggle-label">Ordine singolo</div>
									<div className="single-order-toggle-control">
										<label className="single-order-toggle">
											<input
												type="checkbox"
												checked={parseInt(singleOrderMode) === 1}
												onChange={(e) => setSingleOrderMode(e.target.checked ? 1 : 0)}
											/>
											<span className="single-order-toggle-slider"></span>
										</label>
									</div>
								</div>
							</div>
						)}
					{tempTable.status == 1 &&
						(!tempTable.list_id || tempTable.list?.allyoucaneat == 0) && (
							<div className="boxed-section">
								<div className="covers-count-row">
									<div className="covers-count-text">
										<div className="covers-count-title">Coperti</div>
										<div className="covers-count-help">Aggiungi o modifica</div>
									</div>
									<div className="plus-minus covers-count-control">
										<button
											onClick={() =>
												setCovers(
													parseInt(covers) > 0 ? parseInt(covers) - 1 : 0
												)
											}
										>
											&#8722;
										</button>
										<input
											type="number"
											value={covers}
											onChange={(event) =>
												setCovers(parseInt(event.target.value))
											}
										/>
										<button onClick={() => setCovers(parseInt(covers) + 1)}>
											&#43;
										</button>
									</div>
								</div>
							</div>
						)}
					{tempTable.status == 1 &&
						tempTable.list_id &&
						tempTable.list.allyoucaneat == 1 && (
							<div className="boxed-section">
								<div className="group vertical">
									<p className="text-desc">Aggiungi o modifica i menu:</p>
									{getFilteredProducts("is_selfordering_menu").map(
										(product, i) => (
											<div key={i} className="product-line menu-choice-line">
												<div className="menu-choice-info">
													<div className="menu-choice-name">{product.name}</div>
													<div className="menu-choice-price">
														{functions.formatter.format(product.price)}
													</div>
												</div>
												<div className="plus_minus_container menu-choice-controls">
													{tempTable.status == 1 && (
														<button
															className="btn btn-primary btn-square"
															onClick={() =>
																decrementSplittedCovers(product.id)
															}
														>
															-
														</button>
													)}
													<div>{getSplittedCovers(product.id)}</div>
													{tempTable.status == 1 && (
														<button
															className="btn btn-primary btn-square"
															onClick={() =>
																incrementSplittedCovers(product.id)
															}
														>
															+
														</button>
													)}
												</div>
											</div>
										)
									)}
								</div>
							</div>
						)}
					{tempTable.status == 1 && (
						<div className="table-save-inline">
							<button
								className="btn btn-secondary table-action-fit table-action-save"
								onClick={() =>
									editTableByIdConfirm(tempTable.id, {
										covers: covers,
										splitted_covers: splittedCovers,
										single_order_mode: singleOrderMode,
									})
								}
							>
								Salva modifiche
							</button>
						</div>
					)}
					{tempTable.status == 2 && (
						<div className="boxed-section bg-warning">
							<p className="title">Tavolo in attesa di scontrino</p>
						</div>
					)}
					<Payments table={tempTable} />
				</div>
				<div className="table-actions table-edit-actions">
					{isTabletEmbed && tempTable.status == 1 && (
							<button
								className="btn btn-primary btn-block table-action-full table-action-new-order"
								onClick={() => postToParent({ type: "table-open", table_id: tempTable.id })}
							>
								Consegna al cliente
							</button>
						)}
						{!ordersDisabled && tempTable.status == 1 && (
						<button
							className="btn btn-primary btn-block table-action-full table-action-new-order"
							onClick={handleSubmit}
						>
							Nuova comanda
						</button>
					)}
					<div className="table-actions-grid">
						<button
							onClick={() => setPopupVisible("history")}
							className="btn btn-primary btn-block btn-icon"
						>
							<div className="badge">{tempTable.orders_count}</div>
							Ordini
						</button>
						{canViewRequestBill && tempTable.status == 1 && (
							<button
								className="btn btn-primary btn-block"
								onClick={() => editTableByIdConfirm(tempTable.id, { status: 2 })}
							>
								Richiedi conto
							</button>
						)}
						{canViewRequestBill && tempTable.status == 2 && (
							<button
								className="btn btn-primary btn-block"
								onClick={() => editTableById(tempTable.id, { status: 1, disable_reset: 1 })}
							>
								Annulla richiesta di conto
							</button>
						)}
						{canCloseTables && settings.orders.tables_open_by_filled != 1 && (
							<button
								className="btn btn-primary btn-block"
								onClick={() => editTableByIdConfirm(tempTable.id, { status: 0 })}
							>
								Chiudi Tavolo
							</button>
						)}
					</div>
				</div>
			</div>
		</div>
	);
}

function Payments({ table }) {
	if (table.status != 2) return null;

	const decodeChoice = (id) => {
		if (id == 1) return "Paga l'intero importo";
		if (id == 2) return "Alla romana";
		if (id == 3) return "Quota a scelta";
	};

	const getPayed = () => {
		let res = 0;
		for (const payment of table.payments) {
			res += parseFloat(payment.amount);
		}
		return res;
	};

	const getRemaining = () => {
		let res = 0;
		for (const payment of table.payments) {
			res += parseFloat(payment.amount);
		}
		return parseFloat(table.payments[0].total_amount) - getPayed();
	};

	return (
		<div className="boxed-section">
			<p className="title">Pagamenti</p>
			{table.payments.length > 0 && (
				<div className="mode-payment">
					<p><strong>Modalità:</strong> {decodeChoice(table.payments[0].choice)}</p>
				</div>
			)}

			<div className="gt gt-4">
				{table.payments.map((payment, i) => (
					<Fragment key={i}>
						<div>
							{moment(payment.date_insert, "YYYY-MM-DD HH:mm:ss").format(
								"DD/MM/YYYY HH:mm"
							)}
						</div>
						<div>
							{payment.name} {payment.surname}
						</div>
						<div>{functions.formatter.format(payment.amount)}</div>
						<div>{payment.payment_method_id ? payment.payment_method.name : ""}</div>
					</Fragment>
				))}
			</div>
			{table.payments.length > 0 && (
				<div className="total-payment-rest">
					<div className="total-payment">
						<strong>Totale pagato:</strong> <br></br>{functions.formatter.format(getPayed())} /{" "}
						{functions.formatter.format(table.payments[0].total_amount)}
					</div>
					<div>
						{getRemaining() > 0 && (
							<div className="total-rest"><strong>Ancora da pagare: {functions.formatter.format(getRemaining())}</strong> </div>
						)}
					</div>
				</div>
			)}
		</div>
	);
}

export default TableEditPopup;
